export default __webpack_public_path__ + "static/media/ic_puerto_rico.8b462155.svg";